export default "__VITE_ASSET__BUeV5Oqf__"